// Formatadores compartilhados — antes reimplementados em vários componentes.

// Moeda em Real: R$ 1.234,56
export function fmtMoeda(v) {
  return (parseFloat(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

// Peso: 80g / 1.20kg
export function fmtPeso(g) {
  const n = parseFloat(g) || 0;
  return n >= 1000 ? (n / 1000).toFixed(2) + "kg" : Math.round(n) + "g";
}

// Data dd/mm/aaaa a partir de Date, ISO, ms ou Timestamp do Firestore
function paraData(v) {
  if (!v) return null;
  if (v.toDate) return v.toDate();
  if (v.seconds) return new Date(v.seconds * 1000);
  const d = new Date(v);
  return isNaN(d) ? null : d;
}

export function fmtData(v) {
  const d = paraData(v);
  return d ? d.toLocaleDateString("pt-BR") : "";
}

export function fmtDataHora(v) {
  const d = paraData(v);
  return d ? d.toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "";
}
